import React, { Component } from 'react';
import firebase from './../Firestore'
//import { Link } from 'react-router-dom';

//import config from 'react-global-configuration';

import CategoriaSelector from './CategoriaSelector'
import NavBar from './NavBar'

class AdicionalEdit extends Component {

  categoriaID = React.createRef();

  constructor(props) {
    super(props);
    this.unsubscribe = null;
    this.state = {
      key: '',
      nombre: '',
      categoriaID: '',
      precio: '',
      enStock: ''
    };
  }

  async componentDidMount() {
    const ref = firebase.firestore().collection('adicionales').doc(this.props.match.params.id);
    this.unsubscribe = await ref.get().then((doc) => {
      if (doc.exists) {
        const adicional = doc.data();
        this.setState({
          key: doc.id,
          nombre: adicional.nombre,
          categoriaID: adicional.categoriaID,
          precio: adicional.precio,
          enStock: adicional.enStock,
        });
      } else {
        console.log("No such document!");
      }
    });
  }

  onChange = (e) => {
    const state = this.state

    state[e.target.name] = e.target.value;
    this.setState({adicional:state});

  }

  onSubmit = (e) => {
    e.preventDefault();

    const { nombre, categoriaID, precio, enStock } = this.state;

    const updateRef = firebase.firestore().collection('adicionales').doc(this.state.key);
    updateRef.set({
      nombre,
      categoriaID: this.categoriaID.current.value,
      precio: Number(this.state.precio),
      enStock: Boolean(this.state.enStock)
    }).then((docRef) => {
      this.setState({
        key: '',
        nombre: '',
        categoriaID: '',
        precio: '',
        enStock: ''
      });
      this.props.history.push("/admin/adicional/show/"+this.props.match.params.id)
    })
    .catch((error) => {
      console.error("Error adding document: ", error);
    });
  }




  render() {
    return (
      <div className="container">
        <NavBar history={this.props.history} />
        <div className="panel panel-default">
          <div className="panel-heading">
            <h3 className="panel-title">
              EDITAR ADICIONAL
            </h3>
          </div>
          <div className="panel-body">
            <form onSubmit={this.onSubmit}>
              <div className="form-group">
                <label htmlFor="nombre">Nombre:</label>
                <input type="text" className="form-control" name="nombre" value={this.state.nombre} onChange={this.onChange} placeholder="Nombre" />
              </div>
              <div className="form-group">
                <label htmlFor="categoriaID">Categoria:</label>
                <CategoriaSelector name="categoriaID" categoriaID={this.categoriaID} esAdicional={true} valorActual={this.state.categoriaID} onChange={this.onChange} />

              </div>


              <div className="form-group">
                <label htmlFor="precio">Precio:</label>
                <input type="number" className="form-control" name="precio" value={this.state.precio} onChange={this.onChange} placeholder="Precio" />
              </div>

              <div className="form-group">

                <select value={this.state.enStock} name="enStock" onChange={this.onChange} className="custom-select mt-2">
                  <option value={true}>Hay en stock</option>
                  <option value={false}>No hay en stock</option>
                </select>

              </div>


              <button type="submit" className="btn btn-success">Actualizar</button>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default AdicionalEdit;
